import project01 from './../img/projects/museum2.png'
import project01Big from './../img/projects/museum2.png'
import project02 from './../img/projects/gocorona.png'
import project02Big from './../img/projects/gocorona.png'
import project03 from './../img/projects/air.png'
import project03Big from './../img/projects/air.png'
import project04 from './../img/projects/todo.png'
import project04Big from './../img/projects/todo.png'
import project05 from './../img/projects/growfy.png'
import project05Big from './../img/projects/growfy.png'
import futureTechImg from './../img/projects/Future-tech.jpg'
import reacttodo from './../img/projects/react-todo-2.png'
import reactShop from './../img/projects/reactShop.png'

import project06 from './../img/projects/profol.png'
import project06Big from './../img/projects/profol.png'

export const projects = [
  {
    id: 0,
    title: 'React Shop',
    skills: "React, React Router, JavaScript (ES6+),TypeScript, Responsive UI,State Management (React Context API)",
    img: reactShop,
    imgBig: reactShop,
    link: 'https://beliyandr.github.io/react_phone-catalog/',
    gitHubLink: 'https://github.com/Beliyandr/react_phone-catalog/',
  },

  {
    id: 1,
    title: 'React ToDo App',
    skills: "React, React Router, JavaScript (ES6+), Responsive UI,State Management (React Context API)",
    img: reacttodo,
    imgBig: reacttodo,
    link: 'https://beliyandr.github.io/react_todo-app/',
    gitHubLink: 'https://github.com/Beliyandr/react_todo-app',
  },

  {
    id: 2,
    title: 'Gocorona',
    skills: 'HTML,SCSS,JS',
    img: project02,
    imgBig: project02Big,
    link: 'https://beliyandr.github.io/Verstka_gocorona_/',
    gitHubLink: 'https://github.com/beliyandr/Verstka_gocorona_/',

  },
  {
    id: 3,
    title: 'Air',
    skills: 'HTML,SCSS,JS',
    img: project03,
    imgBig: project03Big,
    link: 'https://beliyandr.github.io/layout_dia/',
    gitHubLink: 'https://github.com/Beliyandr/layout_dia',

  },
  {
    id: 4,
    title: 'TODO-JS',
    skills: 'HTML,CSS,JS',
    img: project04,
    imgBig: project04Big,
    link: 'https://beliyandr.github.io/todoJS/',
    gitHubLink: 'https://github.com/Beliyandr/todoJS',

  },
  {
    id: 5,
    title: 'Growfy',
    skills: 'HTML,CSS,JS',
    img: project05,
    imgBig: project05Big,
    link: 'https://beliyandr.github.io/Grofy/',
    gitHubLink: 'https://github.com/Beliyandr/Grofy',

  },
  {
    id: 6,
    title: 'Portfolio',
    skills: 'HTML,CSS,JS,React, React-router',
    img: project06,
    imgBig: project06Big,
    link: 'https://beliyandr.github.io/react__portf_1/',
    gitHubLink: 'https://github.com/Beliyandr/react__portf_1',

  },
  {
    id: 7,
    title: 'Future-tech',
    skills: 'HTML , SCSS , JS',
    img: futureTechImg,
    imgBig: futureTechImg,
    link: 'https://beliyandr.github.io/future-tech/',
    gitHubLink: 'https://github.com/Beliyandr/future-tech',
  },

  {
    id: 8,
    title: 'Museum',
    skills: 'HTML,SCSS,JS',
    img: project01,
    imgBig: project01Big,
    link: 'https://beliyandr.github.io/Museum_2/',
    gitHubLink: 'https://github.com/beliyandr/Museum_2/',

  },

]
